import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileAudio = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.94375 14.6539C9.45625 14.6539 9.89375 14.4758 10.2563 14.1195C10.6188 13.7633 10.8 13.3289 10.8 12.8164V9.02891H12.975V7.90391H10.05V11.4102C9.9125 11.2977 9.74688 11.2102 9.55313 11.1477C9.35938 11.0852 9.15625 11.0539 8.94375 11.0539C8.45625 11.0539 8.04375 11.2258 7.70625 11.5695C7.36875 11.9133 7.2 12.3289 7.2 12.8164C7.2 13.3164 7.36875 13.7477 7.70625 14.1102C8.04375 14.4727 8.45625 14.6539 8.94375 14.6539ZM5.0625 16.7539C4.7625 16.7539 4.5 16.6414 4.275 16.4164C4.05 16.1914 3.9375 15.9289 3.9375 15.6289V2.87891C3.9375 2.57891 4.05 2.31641 4.275 2.09141C4.5 1.86641 4.7625 1.75391 5.0625 1.75391H11.8313L15.9375 5.86016V15.6289C15.9375 15.9289 15.825 16.1914 15.6 16.4164C15.375 16.6414 15.1125 16.7539 14.8125 16.7539H5.0625ZM11.2688 6.36641V2.87891H5.0625V15.6289H14.8125V6.36641H11.2688Z",
		fill: "#1D1D1D"
	})
});
export default SvgFileAudio;
